export const WindowWidth = {
  DESKTOP: 1280,
  LAPTOP: 1024,
  TABLET: 768,
};
